import { render, staticRenderFns } from "./MeusDadosPessoaisView.vue?vue&type=template&id=22ff71bb&"
import script from "./MeusDadosPessoaisView.vue?vue&type=script&lang=js&"
export * from "./MeusDadosPessoaisView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports